import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate, leftPad, closeCollapsible } from '../../../../utils/util';
import LinePickingService from '../../../../services/LinePickingService';
import { BackButton, Button, Collapsible, InfiniteScroll, Input } from '../../../../components/UI/ComponentsUI';
import CreatePartOutside from './CreatePartOutside';
import { onValueChange } from '../../../../utils/handleChangeHooks';

const MonitorPartOutside = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [partsOutside, setParts] = useState([]);
    const [filter, setFilter] = useState({});

    useEffect(() => {
        if (props.partsOutside?.items?.length > 0) {
            if (partsOutside.length > 0 && currentPage === 0) {
                setParts([...props.partsOutside?.items]);
            } else {
                setParts((prevState) => ([...prevState, ...props.partsOutside.items]));
            }
        } else {
            setParts([]);
        }
        // eslint-disable-next-line
    }, [props?.partsOutside?.items]);

    useEffect(() => {
        getPagedOutSide(false)
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (currentPage > 0) {
            getPagedOutSide(false);
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const getPagedOutSide = (click) => {
        var currentPageList = click ? 0 : currentPage;
        if (click) {
            setCurrentPage(0);
        }

        props.getPagedOutSide({
            ...filter,
            PageSize: 25,
            PageIndex: currentPageList
        }, () => {
            if (click) {
                closeCollapsible("filterOutside")
            }
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const getStatus = (status) => {
        if (status === 1) {
            return (<i className="material-icons orange-text btn-circle-i">report_problem</i>)
        }
        return (<i className={`mdi mdi-48px mdi-alpha-z-circle-outline red-text`} />)
    }

    const deleteRequest = (data) => {
        props.deleteRequestOutSide(data, () => {
            getPagedOutSide(true);
        })
    }
    const renderItem = (item, index) => {
        var data = item.mapping;
        return (
            <>
                <span
                    className="subtitle fourth-text-color right"
                    style={{ position: 'absolute', marginTop: '110px', right: '10px', zIndex: '999', width: '20%', textAlign: 'right' }}
                >
                    {getStatus(item.status)}
                </span>
                <span
                    className="subtitle fourth-text-color right"
                    style={{ position: 'absolute', marginTop: '50px', right: '10px', zIndex: '999', width: '20%', textAlign: 'right' }}
                >
                    <i className="material-icons sixth-text-color"
                        onClick={() => deleteRequest(item)}
                        style={{ fontSize: '1.85rem', cursor: 'pointer' }}>delete</i>
                </span>

                <div
                    className="row"
                    style={{ color: 'black', display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                    key={`oi-${index}`}
                >
                    <div style={{ display: 'block' }}>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className="title black-text col s8 truncate" style={{ padding: '0px', paddingLeft: '0px' }}>
                                {data.partNumber} {data.partNumberDesc}
                            </div>
                            <div className="black-text col s8" style={{ padding: '0px', paddingLeft: '0px' }}>
                                PDU: {data.pdu}
                            </div>
                        </div>
                        <div className="row" style={{ marginBottom: '0px', color: "black" }}>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:qme', 'line-picking')}: ${data.qme || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:mdr', 'line-picking')}: ${data.mdr || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:class', 'line-picking')}: ${data.class || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:space', 'line-picking')}: ${data.space || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:route', 'line-picking')}: ${data.route || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:station', 'line-picking')}: ${data.station || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:street', 'line-picking')}: ${data.street || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:side', 'line-picking')}: ${data.side || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:line', 'line-picking')}: ${data.line || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:model', 'line-picking')}: ${data.model || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:box-limit', 'line-picking')}: ${data.boxLimit || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:gravitational', 'line-picking')}: ${data.gravitational || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:parts', 'line-picking')}: ${data.parts || ''}`}</small>
                            </div>
                            <div className="col s4" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:code', 'line-picking')}: ${`${leftPad(data.id + 1, 9, '0')}` || ''}`}</small>
                            </div>
                            <div className="col s6" style={{ padding: '0px' }}>
                                <small>{`${translate('mapping:quantityAlignment', 'line-picking')}:  ${data.quantityLine || ''}`}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65" />
            <div className="container">
                <Collapsible
                    close="true"
                    id="filterOutside"
                    header={"Filtros"}
                    body={
                        <>
                            <div id="formfilter" className="row">
                                <div className="input-field no-padding col s11">
                                    <Input
                                        id="partNumber"
                                        name='partNumber'
                                        label={translate('mapping:partnumber', 'line-picking')}
                                        type="text"
                                        maxLength="11"
                                        value={filter?.partNumber || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <Input
                                        id="pdu"
                                        name='pdu'
                                        label={translate('mapping:pdu', 'line-picking')}
                                        type="text"
                                        defaultValue={filter?.pdu || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="gravitational"
                                        name='gravitational'
                                        label={translate('mapping:gravitational', 'line-picking')}
                                        type="number"
                                        defaultValue={filter?.gravitational || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <Input
                                        id="station"
                                        name='station'
                                        label={translate('mapping:station', 'line-picking')}
                                        type="number"
                                        maxLength="3"
                                        value={filter?.station || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="createdBy"
                                        name='createdBy'
                                        label={translate('stock:form.user')}
                                        type="text"
                                        maxLength="50"
                                        value={filter?.createdBy || ''}
                                        onChange={onChange}

                                    />
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <Button
                                    full="true"
                                    text={translate('search', 'general')}
                                    onClick={() => getPagedOutSide(true)}
                                />
                            </div>
                        </>
                    }
                />
                <CreatePartOutside
                    callback={() => getPagedOutSide(true)}
                />
            </div>
            <InfiniteScroll
                page={props.partsOutside?.totalPages}
                current={{ currentPage, setCurrentPage }}
                hasMore={currentPage < props.partsOutside?.totalPages}
                data={partsOutside.map((item, index) => {
                    return (renderItem(item, index))
                })}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        partsOutside: state.linePickingReducer.partOutsides
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPagedOutSide: (filter, callback) => {
            dispatch(LinePickingService.getPagedOutSide(filter, callback));
        },
        deleteRequestOutSide: (data, callback) => {
            dispatch(LinePickingService.deleteRequestOutSide(data, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MonitorPartOutside));